import $ from "jquery";
import React, { useEffect, useState } from 'react';
import { Button, Col, Container, Form, Row } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import { useNavigate } from 'react-router-dom';
import * as Common from '../../Common';
import Dialog from '../../Dialog';
import LocationSelector from "../../LocationSelector";
import LoginHeader from '../../Login_header';
import Menu from '../../Menu';

const Rep_rbi_turnover = () => {

    const navigate = useNavigate();
    const sid = sessionStorage.getItem('sessionId');
    const branchDisable = sessionStorage.getItem('branchDisable');
    const [onceRun, setOnceRun] = useState(false);
    const [userRight, setUserRight] = useState([]);
    const [isMsgBox, setMsgBox] = useState(false);
    const [msgText, setMsgText] = useState('');

    const [fromDate, setFromDate] = useState(new Date());
    const [toDate, setToDate] = useState(new Date());
    const [generateType, setGenerateType] = useState("V");

    const [locationCode, setLocationCode] = useState(0);
    const [selectedItems, setSelectedItems] = useState([]);
    const [radioType, setRadioType] = useState("O");
    const [scr, setScr] = useState("");
    const [cnVtm, setCnVtm] = useState("A");
    const [interbranch, setInterbranch] = useState(true);
    const [cardType, setCardType] = useState("A");
    const [filtercurrency, setFilterCurrency] = useState(true);
    const [filterDD, setFilterDD] = useState(true);
    const [filterEdd, setFilterEdd] = useState(true);
    const [filterEtt, setFilterEtt] = useState(true);
    const [filterEvtm, setFilterEvtm] = useState(true);
    const [filterTT, setFilterTT] = useState(true);
    const [filterVtm, setFilterVtm] = useState(true);

    useEffect(() => {
        if (onceRun) {
            return;
        } else {
            Common.callApi(Common.apiRight, [sid, 'all', 'REPORTS_RBI_TURNOVER_ADII'], function (result) {
                let resp = JSON.parse(result);
                if (resp.query === "1") {
                    setUserRight(resp);
                } else {
                    navigate('/');
                }
            });
            setOnceRun(true);
        }
    }, [onceRun, sid, navigate]);

    const handleDataFromChild = (newLocationCode, newSelectedItems, newRadioType) => {
        setLocationCode(newLocationCode);
        setSelectedItems(newSelectedItems);
        setRadioType(newRadioType);
    }

    const handleGenerate = () => {
        $(".loader").show();
        if (!Common.validateFinYear(Common.dateYMD(fromDate), Common.dateYMD(toDate))) {
            $(".loader").hide();
            setMsgBox(true);
            setMsgText("Date should be within financial year");
            return;
        } else if (fromDate > toDate) {
            $(".loader").hide();
            setMsgText("From Date should be less than To Date");
            setMsgBox(true);
            return;
        }

        var msg = [], i = 0;
        if ((radioType === 'O' && locationCode === '0') || (radioType === 'S' && selectedItems.length === 0) ||
            ((!filtercurrency) && (!filterDD) && (!filterEdd) && (!filterEtt) && (!filterEvtm) && (!filterTT) && (!filterVtm))) {
            msg[i++] = ((radioType === 'O' && locationCode == '0') ? "Please select location." : '');
            msg[i++] = ((radioType === 'S' && selectedItems.length === 0) ? "Please select atleast one location." : '');
            msg[i++] = (((!filtercurrency) && (!filterDD) && (!filterEdd) && (!filterEtt) && (!filterEvtm) && (!filterTT) && (!filterVtm)) ? "Please check atleast one checkbox  ." : '');
            $(".loader").hide();
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else {
            const obj = {
                fromDate: Common.dateDMY(fromDate),
                toDate: Common.dateDMY(toDate),
                type: generateType,
                radioTypeLocation: radioType,
                location: locationCode,
                multipleLocation: selectedItems,
                fromDateDMY: Common.dateDMY(fromDate),
                toDateDMY: Common.dateDMY(toDate),
                filterInterbranch: interbranch,
                cardType: cardType,
                filterCN: filtercurrency,
                filterDD: filterDD,
                filterEdd: filterEdd,
                filterEtt: filterEtt,
                filterEvtm: filterEvtm,
                filterTT: filterTT,
                filterVtm: filterVtm
            };
            if (generateType === 'D') {
                Common.callDownloadApiPost1(Common.apirbiturnover, "post", [sid, "rbiTurnoverDownloadReport", JSON.stringify(obj)], result => {
                    $(".loader").hide();
                    setMsgText(Common.buildMessageFromArray([result]));
                    setMsgBox(true);
                });
            } else {
                Common.callApi(Common.apirbiturnover, [sid, "rbiTurnoverViewReport", JSON.stringify(obj)], result => {
                    var newWindow = window.open();
                    newWindow.document.write(result);
                    $(".loader").hide();
                });

            }
        }
    }

    return (
        <>
            <LoginHeader />
            <Menu />
            <Container fluid>
                <Row>
                    <Col>
                        <h3>Report RBI Turnover</h3>
                    </Col>
                </Row>
                <Row>&nbsp;</Row>
                <Row>
                    {/* <Col className='col-md-3 col-6'>
                        <Form.Group>
                            <Form.Label> Card type <span className="text-danger">*</span></Form.Label>
                            <Form.Select value={cardType} onChange={e => setCardType(e.target.value)}
                                required>
                                <option value="A">All</option>
                                <option value="VTM">VTM</option>
                                <option value="EVTM">EVTM</option>
                            </Form.Select>
                        </Form.Group>
                    </Col> */}
                    <Row><h4>Report Period</h4></Row>
                    <Col className='col-md-3 col-6'>
                        <Form.Group>
                            <Form.Label>From Date<span className="colorThemeRed">*</span></Form.Label><br />
                            <DatePicker className="form-control"
                                selected={fromDate}
                                onChange={(date) => setFromDate(date)}
                                dateFormat="dd/MM/yyyy"
                                showYearDropdown
                                showMonthDropdown
                                useShortMonthInDropdown
                                dropdownMode="select"
                                peekNextMonth
                                customInput={
                                    <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                }
                            />
                        </Form.Group>
                    </Col>
                    <Col className='col-md-3 col-6'>
                        <Form.Group>
                            <Form.Label>To Date<span className="colorThemeRed">*</span></Form.Label><br />
                            <DatePicker className="form-control"
                                selected={toDate}
                                onChange={(date) => setToDate(date)}
                                dateFormat="dd/MM/yyyy"
                                showYearDropdown
                                showMonthDropdown
                                useShortMonthInDropdown
                                dropdownMode="select"
                                peekNextMonth
                                customInput={
                                    <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                }
                            />
                        </Form.Group>
                    </Col>
                    <Col className='col-md-3 col-6'>
                        <Form.Group>
                            <Form.Label>Mode<span className="text-danger">*</span></Form.Label>
                            <Form.Select value={generateType} onChange={e => setGenerateType(e.target.value)}
                                required>
                                <option value="V">View</option>
                                <option value="D">Download</option>
                                {/* <option value="P">PDF</option> */}
                            </Form.Select>
                        </Form.Group>
                    </Col>
                </Row>
                <Row>&nbsp;</Row>
                <Row>
                    <Col>
                        <Form.Check
                            size='sm'
                            type="checkbox"
                            label="Currency "
                            checked={filtercurrency}
                            onChange={() => setFilterCurrency(!filtercurrency)}
                        />
                    </Col>
                    <Col>
                        <Form.Check
                            size='sm'
                            type="checkbox"
                            label="VTM "
                            checked={filterVtm}
                            onChange={() => setFilterVtm(!filterVtm)}
                        />
                    </Col>
                    <Col>
                        <Form.Check
                            size='sm'
                            type="checkbox"
                            label="EVTM "
                            checked={filterEvtm}
                            onChange={() => setFilterEvtm(!filterEvtm)}
                        />
                    </Col>
                    <Col>
                        <Form.Check
                            size='sm'
                            type="checkbox"
                            label="DD "
                            checked={filterDD}
                            onChange={() => setFilterDD(!filterDD)}
                        />
                    </Col>
                    <Col>
                        <Form.Check
                            size='sm'
                            type="checkbox"
                            label="TT"
                            checked={filterTT}
                            onChange={() => setFilterTT(!filterTT)}
                        />
                    </Col>
                    <Col>
                        <Form.Check
                            size='sm'
                            type="checkbox"
                            label="EDD "
                            checked={filterEdd}
                            onChange={() => setFilterEdd(!filterEdd)}
                        />
                    </Col>
                    <Col>
                        <Form.Check
                            size='sm'
                            type="checkbox"
                            label="ETT "
                            checked={filterEtt}
                            onChange={() => setFilterEtt(!filterEtt)}
                        />
                    </Col>
                    <Col>
                        <Form.Check
                            size='sm'
                            type="checkbox"
                            label="Show inter branch "
                            checked={interbranch}
                            onChange={() => setInterbranch(!interbranch)}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col className='col-md-6 col-6'>
                        <Form.Label>Location Filter</Form.Label><br />
                        <LocationSelector onDataFromChild={handleDataFromChild} />
                    </Col>
                </Row>
                <Row>&nbsp;</Row>
                <Row>
                    <Col>
                        <Button variant='outline-success' className='buttonStyle' size='sm' onClick={handleGenerate}>Generate</Button>
                    </Col>
                </Row>
                <Row>&nbsp;</Row>

            </Container >
            <Dialog isOpen={isMsgBox} onClose={(e) => setMsgBox(false)}>
                {msgText}
            </Dialog>
            <Row>&nbsp;</Row>
            <Row>&nbsp;</Row>
            <Row>&nbsp;</Row>
        </>
    )
}

export default Rep_rbi_turnover;